import { render } from "./InvoicesPage.vue?vue&type=template&id=21ddc453&scoped=true&ts=true"
import script from "./InvoicesPage.ts?vue&type=script&lang=ts"
export * from "./InvoicesPage.ts?vue&type=script&lang=ts"

import "./InvoicesPage.vue?vue&type=style&index=0&id=21ddc453&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ddc453"]])

export default __exports__